/**
 * 此组件封装页面头部，包含menu栏
 */
import React, { PureComponent } from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Dropdown, Icon, Menu, message, Select } from "antd/lib/index";
import baseMethods from "../../../api/baseMethods";
import "./header.scss";
import "antd/dist/antd.css";
import utils from "../../../libs/utils"; // ES6
import authApi from "../../../api/auth/auth";
import paymentApi from "../../../api/payment/payment";
import messageApi from "../../../api/message/message";
import main_routes_all from "../../../router/main_routes_all";
import Product from "./product";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import { connect } from "react-redux";
import { switchLeftNav } from "./../../../store/actionDispatch/index";

const SubMenu = Menu.SubMenu;
const { Option } = Select;
let init_timer = 120; //minutes
let active_timer = init_timer;
let timer_running_interval = null;
let user_code_now = "";
let lyc_base_routes = utils.localStorageGet("lyc_base_routes");
let active_auth_domain = lyc_base_routes["active_auth_domain"];
let reset_timer_func = () => {
  active_timer = init_timer;
};

let role_resource_arr = [
  {
    permissions: ["*"],
    resource_code: "MDaklbVmWU6OYUPvcRPUflwlZbzOjhvt",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "OOgZ96eQMHyKUAqA4nd9Xr4jSh2ZxSL3",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "h7VNshWqOFqn2RWdImnDhE0mftfqDrbI",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "q0AEFsjaTepI3WTAvqdGtmlfBfam92jA",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "rl1B102wevFRXjnRei8xNbAGqRc7EfNK",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "rivXRCEEFcnVZmLPhEowY8S5GzEzYXXG",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "tcPeRPGdEFzCzWoA3EBHRvJb8K59yZEq",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "F8Fi1phVanhBsoS9cq4EUIYfZM8q6AsT",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "1ZJAoISoR3KJ47Mu7WgFcxQSsaHaPXg9",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "xhTA3MuIBXQrJL6A5yHXmDzhS9U0xAsB",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "yWCAzZjBUIcql9I4HcAqLme7xxXF95R8",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "1qaO36n2xFH70W8BLsh1z0Q8aJDHWvzU",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "zSHlBDTseC9AMnoT2rsgQo8uTmUEQxlf",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
  {
    permissions: ["*"],
    resource_code: "mDBPqGjsEJMG6O2BFieelIyck2yk4QaJ",
    site_code: "0f8b582c52d640c286ff0c8a0f26a877",
  },
];

class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      current_menu: "0",
      siteInfo: [],
      login_name: null,
      commodityCategories: null,
      lingyun_user_auth: [],
      lingyun_manage_auth: [],
      sobey_web_link:
        "http://www.sobey.com/index.php?m=content&c=index&a=lists&catid=56",
    };
  }

  componentDidMount() {
    this.account_or_third_party_auto_login();
    this.init_user_pay();
    this.isSubUserCode();
    this.changeStateCurrent();
    this.getSAASsiteList();
    this.monitor_mouse_and_keyboard();
    this.set_sobey_web_link();
  }

  componentWillUnmount() {
    this.remove_mou_and_keyb_monitor();
  }

  /*输入账号密码登录，或者第三方免登录*/
  account_or_third_party_auto_login = () => {
    let req_code01 = utils.getQueryValue("hash", "code");
    let req_code02 = utils.getQueryValue("browser", "code");
    let req_code = req_code01 ? req_code01 : req_code02;
    console.log("101-1-req_code", req_code);
    if (req_code) {
      /*用code去中间件走登录流程，获取用户信息*/
      this.mid_ware_code_to_token(req_code);
    } else {
      /*查询是否需要免登录，如果需要就跳转到认证中心的登录页面，然后会自动走登录流程*/
      this.quick_share_auth();
    }

    let user_name_now = utils.localStorageGet("lingyun_login_username");

    if (user_name_now) {
      this.setState({ login_name: user_name_now });
      this.req_resource_menus(); //获取被授权的模块
    }
  };

  /*监听鼠标和键盘动作，长时间在本页面不操作就退出*/
  monitor_mouse_and_keyboard = () => {
    timer_running_interval = setInterval(() => {
      active_timer -= 1;
      if (active_timer < 1) {
        message.warning(init_timer + this.props.t("h_minutes_log_out"));
        // utils.localStorageSet('re_login_backup_url', window.location.href);
        setTimeout(() => {
          this.lyc_logout();
        }, 5000);
      }
    }, 60 * 1000);
    if (document) {
      document.addEventListener("mousemove", reset_timer_func);
      document.addEventListener("keydown", reset_timer_func);
    }
  };

  /*移除监听事件*/
  remove_mou_and_keyb_monitor = () => {
    timer_running_interval = null;
    document.removeEventListener("mousemove", reset_timer_func);
    document.removeEventListener("keydown", reset_timer_func);
  };

  /*中间件code换token-redis存放-返回用户信息*/
  mid_ware_code_to_token = (req_code) => {
    if (req_code) {
      /*去中间件用code换取token, 返回token状态以及该token对应的用户信息。*/
      authApi.mid_ware_session_token(req_code).then((res) => {
        console.log("mid_ware_code_to_token--res:", res);

        if (res && "success" === res["state"]) {
          if (res["data"]) {
            let data_json = res["data"];
            utils.localStorageSet(
              "lingyun_login_username",
              data_json["username"],
            );
            utils.localStorageSet(
              "lingyun_login_usercode",
              data_json["user_code"],
            );

            utils.localStorageSet("siteCode", data_json["site"]);

            let target_after_auth = baseMethods.web_domain;
            const remem_href = utils.localStorageGet("remember_href");
            if (remem_href && remem_href.length > 10) {
              utils.localStorageSet("remember_href", "no");
              target_after_auth = remem_href;
            }
            window.location.href = target_after_auth;
          }
        }
      });
    }
  };

  goto_auth_center_signIn = () => {
    window.open(baseMethods.auth_center_singIn, "_self");
  };

  goto_auth_center_signUp = () => {
    window.open(baseMethods.auth_center_singUp, "_self");
  };

  //初始化角色和金额
  init_user_pay = () => {
    /*1、获取用户代码和用户名称*/
    console.log("1/7、获取用户代码和用户名称");
    let usercode = utils.localStorageGet("lingyun_login_usercode");
    let username = utils.localStorageGet("lingyun_login_username");
    let payload = {
      account: username,
      accountId: usercode,
    };
    if (usercode) {
      /*2、调取userMe接口，获取用户信息*/
      console.log("2/7、调取userMe接口，获取用户信息");
      authApi.userMe().then(async (res) => {
        if (res) {
          let site = res.site;
          let check_param = {
            accountId: usercode,
          };
          /*                    /!*6、lgc新接口，统一初始化用户角色*!/
                                        let init_params = {
                                            siteCode:site,
                                            userCode:usercode,
                                        };
                                        console.log('2021-04-06 init_user_role_in_all_system init_params', init_params);
                                        authApi.init_user_role_in_all_system(init_params);*/

          /*3、调取支付模块接口，确认是否需要同步余额和代金券账号*/
          console.log(
            "3/7、调取支付模块接口，确认是否需要同步余额和代金券账号",
          );
          let check_balance_res =
            await paymentApi.checkBalanceAccount(check_param);
          let check_voucher_res =
            await paymentApi.checkVoucherAccount(check_param);

          if (check_balance_res && check_balance_res) {
            let balance_res_final =
              Array.isArray(check_balance_res) &&
              0 === check_balance_res.length;
            let voucher_res_final =
              Array.isArray(check_voucher_res) &&
              0 === check_voucher_res.length;

            /*4、如果用户中心反馈的用户信息res["initialized"]为空 或者 余额账户信息为空 或者 代金券账号为空， 都需要重新同步账号*/
            console.log(
              '4/7、res["initialized"]为空 或者 余额账户信息为空 或者 代金券账号为空， 都需要重新同步账号',
            );
            console.log(
              "4/7、a or b or c",
              res["initialized"] === false,
              balance_res_final,
              voucher_res_final,
            );
            if (
              res["initialized"] === false ||
              balance_res_final ||
              voucher_res_final
            ) {
              // if ( balance_res_final || voucher_res_final) {
              utils.localStorageSet("siteCode", res.site);

              payload.siteCode = utils.localStorageGet("siteCode");

              let data = {
                name: "admin",
                description: "用户基础权限",
              };

              /*5、调取认证中心接口，初始化用户的基础权限*/
              console.log("5/7、调取认证中心接口，初始化用户的基础权限");
              await authApi.addUserGroup(data, site);

              let my_lyc_role_resrc =
                utils.localStorageGet("lyc_role_resource");
              let role_datas = my_lyc_role_resrc
                ? my_lyc_role_resrc
                : role_resource_arr;
              role_datas.map((item) => {
                item.site_code = site;
                return null;
              });

              /*6、调取认证中心接口，初始化用户的角色*/
              console.log("6/7、调取认证中心接口，初始化用户的角色");
              let my_role_code = utils.localStorageGet("role_code"); //32位随机数，调取auth.addUserGroup的时候已经生成。
              await authApi.setRoleResource(my_role_code, role_datas, site);
              let initState = await authApi.init_state(payload.accountId);
              let initRole_two = await authApi.syncRole(
                my_role_code,
                [usercode],
                site,
              );

              /*7、开始同步认证中心和支付模块的账号*/
              console.log("7/7、开始同步认证中心和支付模块的账号");
              let initInfo = await paymentApi.syncInfo(payload); //余额
              let initVoucher = await paymentApi.syncVoucher(payload); //代金券
              Promise.all([
                initState,
                initRole_two,
                initInfo,
                initVoucher,
              ]).then(async (res) => {
                if (-1 === window.location.href.indexOf("moccloud")) {
                  await messageApi.welcomeInfo(payload);
                  console.log("await messageApi.welcomeInfo(payload) __01");
                }
                setTimeout(() => {
                  console.log("this.req_resource_menus() __02");
                  this.req_resource_menus();
                }, 1000);
              });
            }
          }
        }
      });
    }
  };

  /*设置状态current*/
  changeStateCurrent() {
    let id = window.location.pathname;
    switch (id) {
      case "/media":
        this.setState({
          current_menu: "1",
        });
        break;
      case "/mediacloud":
        this.setState({
          current_menu: "2",
        });
        break;
      case "/smartcloud":
        this.setState({
          current_menu: "3",
        });
        break;
      case "/clue":
        this.setState({
          current_menu: "4",
        });
        break;
      case "/ai":
        this.setState({
          current_menu: "5",
        });
        break;
      case "/cloudLive":
        this.setState({
          current_menu: "6",
        });
        break;
      case "/promediaapp":
        this.setState({
          current_menu: "7",
        });
        break;
      case "/lightmedia":
        this.setState({
          current_menu: "8",
        });
        break;
      case "/news":
        this.setState({
          current_menu: "9",
        });
        break;
      case "/operation":
        this.setState({
          current_menu: "10",
        });
        break;
      case "/case":
        this.setState({
          current_menu: "11",
        });
        break;
      case "/magicbox":
        this.setState({
          current_menu: "12",
        });
        break;
      case "/about":
        this.setState({
          current_menu: "13",
        });
        break;
      case "/downloads":
        this.setState({
          current_menu: "14",
        });
        break;
      default:
        this.setState({
          current_menu: "1",
        });
    }
  }

  clickTopMenu = (e) => {
    this.setState({ current_menu: e.key });
  };

  clickTopSubMenu = (value) => {
    this.setState({ current_menu: value });
  };

  // 调用登出接口 退出成功跳转登录页
  lyc_logout = () => {
    this.remove_mou_and_keyb_monitor();
    const user_code_now = utils.localStorageGet("lingyun_login_usercode");
    authApi
      .remove_mid_ware_key(user_code_now)
      .then((res) => {
        console.log("416-remove_mid_ware_key--res", res);
        this.delete_local_user_info();
      })
      .catch((err01) => {
        console.error(
          "419-fjiang6_mid_ware remvoe redis key failed 02!",
          err01,
        );
      });
  };

  delete_local_user_info = () => {
    console.log("424-delete_local_user_info");
    localStorage.removeItem("lingyun_login_username");
    localStorage.removeItem("lingyun_login_usercode");
    localStorage.removeItem("lingyun_login_subusercode");
    localStorage.removeItem("web_to_web_target");
    localStorage.removeItem("already_load_Market");
    localStorage.removeItem("workOrder");
    localStorage.removeItem("lyc_role_resource");
    localStorage.removeItem("siteCode");
    utils.delete_cookie_all();
    this.setState(
      {
        login_name: null,
        lingyun_user_auth: [],
      },
      () => {
        message.success(this.props.t("h_log_out_success"));
        setTimeout(() => {
          window.location.href =
            active_auth_domain +
            `/logout?redirect_uri=${baseMethods.web_domain}`;
        }, 1000);
      },
    );
  };

  /*获取站点列表*/
  getSAASsiteList = () => {
    if (window.localStorage.getItem("siteInfo")) {
      let siteInf01 = JSON.parse(window.localStorage.getItem("siteInfo"));
      this.setState({
        siteInfo: siteInf01,
      });
    }
  };

  /*页面替换*/
  replace_with_new_page = (targetUrl) => {
    const lyc_overviews =
      baseMethods.web_domain + `/console/#/lyc_lingyun/lyc_overviews`;
    let new_page_type = "_self";
    let final_target = "";
    if ("lyc_user/userInfo" === targetUrl) {
      final_target = this.goto_userCenter_initPage(); //跳转用户中心初始页面
      utils.localStorageSet("web_to_web_target", final_target);
      new_page_type = "_self";
    } else if ("lyc_manage" === targetUrl) {
      final_target = this.goto_manage_initPage(); //跳转管理平台初始页面
      new_page_type = "_blank";
    } else if (
      "lyc_overviews" === targetUrl &&
      this.state.lingyun_user_auth[0]
    ) {
      final_target = lyc_overviews;
      utils.localStorageSet("web_to_web_target", final_target);
      new_page_type = "_self";
    }
    window.open(final_target, new_page_type);
  };

  /*跳转用户中心初始页面*/
  goto_userCenter_initPage = () => {
    let temp_user = this.state.lingyun_user_auth[0];
    if (temp_user) {
      let init_user_name_01 =
        temp_user["children"] && temp_user["children"].length > 0
          ? temp_user["children"][0]["name"]
          : null;
      let init_user_name_02 = temp_user["name"];
      let init_user_name = init_user_name_01
        ? init_user_name_01
        : init_user_name_02;
      let target_user_page = "";
      if ("用户信息" === init_user_name) {
        target_user_page = "/userInfo";
      } else if ("安全设置" === init_user_name) {
        target_user_page = "/securityOption";
      } else if ("子账号列表" === init_user_name) {
        target_user_page = "/accountsList";
      } else if ("用户组" === init_user_name) {
        target_user_page = "/userGroup";
      } else if ("余额管理" === init_user_name) {
        target_user_page = "/balanceManage";
      } else if ("我的订单" === init_user_name) {
        target_user_page = "/orders";
      } else if ("我的服务" === init_user_name) {
        target_user_page = "/myService";
      } else if ("我的套餐" === init_user_name) {
        target_user_page = "/myPackage";
      } else if ("我的工单" === init_user_name) {
        target_user_page = "/myWorkOrder";
      } else if ("提交工单" === init_user_name) {
        target_user_page = "/submitWorkOrder";
      } else if ("消息箱" === init_user_name) {
        target_user_page = "/messageBox";
      } else if ("发票管理" === init_user_name) {
        target_user_page = "/invoiceManage";
      }
      let user_page_url =
        baseMethods.web_domain +
        `/console/#/lyc_lingyun/lyc_user${target_user_page}`;
      return user_page_url;
    }
  };

  /*跳转管理平台初始页面*/
  goto_manage_initPage = () => {
    let temp_manage = this.state.lingyun_manage_auth[0];
    if (temp_manage) {
      let init_manage_name_01 =
        temp_manage["children"] && temp_manage["children"].length > 0
          ? temp_manage["children"][0]["name"]
          : null;
      let init_manage_name_02 = temp_manage["name"];
      let init_manage_name = init_manage_name_01
        ? init_manage_name_01
        : init_manage_name_02;
      let target_mange_page = "";
      if ("平台状态" === init_manage_name) {
        target_mange_page = "/platformStatus";
      } else if ("发布商品" === init_manage_name) {
        target_mange_page = "/reComStepOne";
      } else if ("商品管理" === init_manage_name) {
        target_mange_page = "/commodityManage";
      } else if ("工单管理" === init_manage_name) {
        target_mange_page = "/jobOrderReply";
      } else if ("公告管理" === init_manage_name) {
        target_mange_page = "/announceManage";
      } else if ("广播管理" === init_manage_name) {
        target_mange_page = "/broadcastManage";
      } else if ("消息模板" === init_manage_name) {
        target_mange_page = "/messageModel";
      } else if ("全部服务" === init_manage_name) {
        target_mange_page = "/orderList";
      } else if ("订单查询" === init_manage_name) {
        target_mange_page = "/billSearch";
      } else if ("套餐管理" === init_manage_name) {
        target_mange_page = "/packageManage";
      } else if ("发票开具" === init_manage_name) {
        target_mange_page = "/invoiceIssuing";
      } else if ("用户管理" === init_manage_name) {
        target_mange_page = "/usersManage";
      } else if ("角色管理" === init_manage_name) {
        target_mange_page = "/roleManage";
      } else if ("资源管理" === init_manage_name) {
        target_mange_page = "/resourceManage";
      } else if ("代金券管理" === init_manage_name) {
        target_mange_page = "/couponManage";
      } else if ("发票管理" === init_manage_name) {
        target_mange_page = "/invoiceManage";
      } else if ("折扣管理" === init_manage_name) {
        target_mange_page = "/discountManage";
      }
      let lyc_manage = baseMethods.web_domain + "/manage/#" + target_mange_page;
      return lyc_manage;
    }
  };

  /*跳转到商品详情*/
  go_to_commo_details = (commo_id) => {
    let target_url =
      main_routes_all.pages.commodityTemplate + "?commodity_uuid=" + commo_id;
    this.props.history.push(target_url);
    this.clickTopSubMenu("media_cloud");
  };

  /*获取该用户被授权的模块*/
  req_resource_menus = (data) => {
    //是否有父账号
    authApi
      .getParentUser(
        utils.localStorageGet("lingyun_login_subusercode")
          ? utils.localStorageGet("lingyun_login_subusercode")
          : utils.localStorageGet("lingyun_login_usercode"),
      )
      .then((res) => {
        if (data && data === "time") {
          user_code_now = utils.localStorageGet("lingyun_login_subusercode")
            ? utils.localStorageGet("lingyun_login_subusercode")
            : utils.localStorageGet("lingyun_login_usercode");
        } else {
          if (res.login_name) {
            utils.localStorageSet("siteCode", res.site);
            let sub_user_code = utils.localStorageGet("lingyun_login_usercode");
            utils.localStorageSet("lingyun_login_usercode", res.user_code);
            utils.localStorageSet("lingyun_login_subusercode", sub_user_code);
            user_code_now = sub_user_code;
          } else {
            utils.localStorageSet("lingyun_login_subusercode", "");
            user_code_now = utils.localStorageGet("lingyun_login_usercode");
          }
        }
        if (user_code_now) {
          authApi.resource_menus(user_code_now).then((res) => {
            if (res) {
              let temp_auth = JSON.parse(JSON.stringify(res));
              let lingyun_market = null;
              for (let key in temp_auth) {
                if ("索贝凌云商城" === temp_auth[key]["name"]) {
                  lingyun_market = temp_auth[key]["children"];
                  break;
                }
              }
              let lingyun_manage = null;
              let lingyun_user = null;
              for (let key2 in lingyun_market) {
                if ("管理平台" === lingyun_market[key2]["name"]) {
                  lingyun_manage = lingyun_market[key2]["children"];
                }
                if ("用户中心" === lingyun_market[key2]["name"]) {
                  lingyun_user = lingyun_market[key2]["children"];
                }
              }
              this.setState({
                lingyun_user_auth: lingyun_user ? lingyun_user : [],
                lingyun_manage_auth: lingyun_manage ? lingyun_manage : [],
              });
            }
          });
        }
      });
  };

  isSubUserCode = async () => {
    //是否有父账号 子账号登录
    let usercode = utils.localStorageGet("lingyun_login_usercode");
    if (usercode) {
      let res = await authApi.userMe();
      if (res.parent_code) {
        //有父账号 -- 登录的就是子账号
        utils.localStorageSet("lingyun_login_usercode", res.parent_code);
        utils.localStorageSet("lingyun_login_subusercode", res.user_code);
      } else {
        utils.localStorageSet("lingyun_login_subusercode", "");
        utils.localStorageSet("lingyun_login_usercode", res.user_code);
        utils.localStorageSet("siteCode", res.site);
      }
      this.req_resource_menus("time");
    }
  };

  goto_help_manual = () => {
    window.open(
      baseMethods.web_domain + "/doc/lyc_doc/sobey_lingyun_user_manual.pdf",
      "_blank",
    );
  };

  /*配置第三方免登录*/
  quick_share_auth = () => {
    console.log("配置第三方免登录_quick_share_auth");
    let check_code_and_login = () => {
      let user_code = utils.localStorageGet("lingyun_login_usercode");
      console.log("101-2-signIn_user_code:", user_code);
      if (!user_code) {
        this.goto_auth_center_signIn();
      }

      /*购买与续费，更流畅的免登录*/
      const remem_href = utils.localStorageGet("remember_href");
      if (user_code && remem_href && remem_href.length > 10) {
        utils.localStorageSet("remember_href", "no");
        window.location.href = remem_href;
      }
    };

    let check_share_auth = () => {
      let lyc_base_routes = utils.localStorageGet("lyc_base_routes");
      let logged_in = utils.getCookieFunc(
        lyc_base_routes["logged_in_cookie_name"],
      );
      console.log("logged_in_cookie_name", logged_in);

      if (logged_in && "yes" === logged_in) {
        setTimeout(() => {
          check_code_and_login();
        }, 1000);
      }

      if (logged_in && "no" === logged_in) {
        setTimeout(() => {
          let user_name = utils.localStorageGet("lingyun_login_username");
          let user_code = utils.localStorageGet("lingyun_login_usercode");
          console.log("709--user_name-user_code:", user_name, user_code, "end");
          if (
            (user_name && "" !== user_name) ||
            (user_code && "" !== user_code)
          ) {
            console.log(" this.lyc_logout()-711");
            this.lyc_logout();
          }
        }, 1000);
      }
    };

    check_share_auth();

    setInterval(
      () => {
        check_share_auth();
      },
      1000 * 60 * 5,
    );
  };

  lang_change = (value) => {
    utils.localStorageSet("current_language", value);
    i18n.changeLanguage(value);
    this.props.switchMenu(null);
    this.set_sobey_web_link();
    setTimeout(() => {
      this.props.switchMenu(value);
    }, 5000);
  };

  set_sobey_web_link = () => {
    const my_lang = utils.localStorageGet("current_language");
    let my_web_link = "";
    if ("zh" === my_lang) {
      my_web_link =
        "http://www.sobey.com/index.php?m=content&c=index&a=lists&catid=56";
    } else {
      my_web_link = "http://international.sobey.com/index.php";
    }
    this.setState({
      sobey_web_link: my_web_link,
    });
  };

  render() {
    const { t } = this.props;

    const hide_commodity_menu = () => {
      this.child.hide_commodity_menu();
    };
    const show_commodity_menu = () => {
      this.child.show_commodity_menu();
    };
    const header_right_menu = (
      <Menu>
        {this.state.lingyun_user_auth[0] ? (
          <Menu.Item
            onClick={this.replace_with_new_page.bind(this, "lyc_user/userInfo")}
          >
            <span className="menuDropItemTxt">{t("h_user_center")}</span>
          </Menu.Item>
        ) : null}
        {this.state.lingyun_manage_auth[0] ? (
          <Menu.Item
            onClick={this.replace_with_new_page.bind(this, "lyc_manage")}
          >
            <span className="menuDropItemTxt">{t("h_manage_platform")}</span>
          </Menu.Item>
        ) : null}
        <Menu.Item onClick={this.lyc_logout}>
          <span className="menuDropItemTxt" rel="noopener noreferrer">
            {t("h_log_out")}
          </span>
        </Menu.Item>
      </Menu>
    );
    return (
      <header
        id="header"
        className="lingyun_market_main_header"
        onMouseEnter={hide_commodity_menu}
      >
        <div className="main_header_logo">
          <Link to={main_routes_all.pages.default} className="menu_a_all ">
            <img
              src={baseMethods.base_images_Url.imgLogo}
              height="35px"
              alt="img"
            />
          </Link>
        </div>
        <Menu
          onClick={this.clickTopMenu}
          selectedKeys={[this.state.current_menu]}
          mode="horizontal"
          className="main_header_menu"
        >
          <SubMenu
            key="media_cloud"
            className={
              "media_cloud" === this.state.current_menu
                ? "main_header_commodity_list top_sub_menu active_top_menu"
                : "main_header_commodity_list top_sub_menu"
            }
            onTitleMouseEnter={show_commodity_menu}
            title={
              <div>
                <Link to={main_routes_all.pages.home} className="menu_a_all">
                  <div
                    className="top_sub_menu_title"
                    onClick={this.clickTopSubMenu.bind(this, "media_cloud")}
                  >
                    <span>{t("h_products")}</span>
                    <Icon type="caret-down" />
                  </div>
                </Link>
                <Product
                  go_toFun={this.go_to_commo_details}
                  ref={(ref) => {
                    this.child = ref;
                  }}
                />
              </div>
            }
          />
          <SubMenu
            key="media_solution"
            onTitleMouseEnter={hide_commodity_menu}
            className={
              "media_solution" === this.state.current_menu
                ? "top_sub_menu active_top_menu"
                : "top_sub_menu"
            }
            title={
              <Link
                to={main_routes_all.pages.lightMedia}
                className="menu_a_all"
              >
                <div
                  className="top_sub_menu_title"
                  onClick={this.clickTopSubMenu.bind(this, "media_solution")}
                >
                  <span>{t("h_solutions")}</span>
                  <Icon type="caret-down" />
                </div>
              </Link>
            }
          >
            <Menu.Item key="lightMedia">
              <Link to={main_routes_all.pages.lightMedia}>
                {t("h_video_cloud_solutions")}
              </Link>
            </Menu.Item>
            <Menu.Item key="news">
              <Link to={main_routes_all.pages.news}>
                {t("h_news_outfield_solutions")}
              </Link>
            </Menu.Item>
            <Menu.Item key="integrationMedia">
              <Link to={main_routes_all.pages.integrationMedia}>
                {t("h_integrated_media_solutions")}
              </Link>
            </Menu.Item>
            <Menu.Item key="provincePlatform">
              <Link to={main_routes_all.pages.provincePlatform}>
                {t("h_state_platform_solutions")}
              </Link>
            </Menu.Item>
          </SubMenu>

          {/* <Menu.Item key="mBox" className={"mBox" === this.state.current_menu ? " active_top_menu" : ""}>
                        <a target="view_window" href="http://mbox.sobeylingyun.com/" className="menu_a_all">
                            {t("h_sobey_magic_box")}
                        </a>
                    </Menu.Item> */}

          <SubMenu
            key="service_support"
            onTitleMouseEnter={hide_commodity_menu}
            className={
              "service_support" === this.state.current_menu
                ? "top_sub_menu active_top_menu"
                : "top_sub_menu"
            }
            title={
              <Link
                to={main_routes_all.pages.noticeInfo}
                className="menu_a_all"
              >
                <div
                  className="top_sub_menu_title"
                  onClick={this.clickTopSubMenu.bind(this, "service_support")}
                >
                  <span>{t("h_service_and_support")}</span>
                  <Icon type="caret-down" />
                </div>
              </Link>
            }
          >
            <Menu.Item key="noticeInfo">
              <Link to={main_routes_all.pages.noticeInfo}>{t("h_notice")}</Link>
            </Menu.Item>
            <Menu.Item key="contactUs">
              <Link to={main_routes_all.pages.contactUs}>
                {t("h_contact_us")}
              </Link>
            </Menu.Item>
            <Menu.Item key="helpManual">
              <span onClick={this.goto_help_manual}>{t("h_help_info")}</span>
            </Menu.Item>
          </SubMenu>

          <Menu.Item
            key="aboutUs"
            className={
              "aboutUs" === this.state.current_menu ? " active_top_menu" : ""
            }
          >
            <a
              target="view_window"
              className="menu_a_all"
              href={this.state.sobey_web_link}
            >
              {t("h_about_us")}
            </a>
          </Menu.Item>
        </Menu>

        <div className="main_header_console_sign">
          {this.state.lingyun_user_auth[0] &&
          utils.localStorageGet("lingyun_login_usercode") ? (
            <div className="main_header_console">
              {this.state.login_name ? (
                <span
                  className="head_go_to_console "
                  onClick={this.replace_with_new_page.bind(
                    this,
                    "lyc_overviews",
                  )}
                >
                  {t("h_console")}
                </span>
              ) : (
                <Link
                  className="head_go_to_console menu_a_all"
                  to={
                    main_routes_all.sign.signIn + "?targetPage=consoleOverview"
                  }
                >
                  {t("h_console")}
                </Link>
              )}
            </div>
          ) : null}

          <div className="main_header_sign">
            {this.state.login_name ? (
              <Dropdown overlay={header_right_menu} className="user_name">
                <span className="ant-dropdown-link login-name menu_a_all">
                  {this.state.login_name} <Icon type="down" />
                </span>
              </Dropdown>
            ) : (
              <div className="header_sign_btns">
                <Button
                  onClick={this.goto_auth_center_signUp}
                  className="header_signup header_login_btn"
                >
                  {t("h_register")}
                </Button>
                <Button
                  onClick={this.goto_auth_center_signIn}
                  type={"primary"}
                  className="header_signin header_login_btn"
                >
                  {t("h_log_in")}
                </Button>
              </div>
            )}
            {/*                        <Select defaultValue={utils.localStorageGet('current_language')} style={{width: 85}}
                                onChange={this.lang_change} className={"language_change_select"}>
                            <Option value="zh">中文</Option>
                            <Option value="en">English</Option>
                        </Select>*/}
          </div>
        </div>

        <div className="main_header_contact_us">
          <Link to={main_routes_all.pages.contactUs}>
            <p className="main_header_contact_us_logo">
              <Icon type="message" />
            </p>
            <p className="main_header_contact_us_txt">
              {t("h_contact_us_icon")}
            </p>
          </Link>
        </div>
      </header>
    );
  }
}

/*获取state中数据*/
const mapStateToProps = (state) => {
  return {
    activeLeftNav: state.leftNavReducer.activeLeftNav,
  };
};

/*修改state中数据*/
const appDispatch = (dispatch) => {
  return {
    switchMenu: (prodItem) => {
      dispatch(switchLeftNav(prodItem));
    },
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, appDispatch)(Header)),
);



// WEBPACK FOOTER //
// ./src/view/components/header/header.js